 import React from "react";

const Footer = (props) => {
  let d = new Date();
  return (
    <div className={`footer ${props.changeFooter}`}>
      <div className="copyright">
        <p>
          Copyright © by{" "}
          <a href="http://schoolmedia.id/" target="_blank" rel="noreferrer">
            Schoolmedia
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
